import { AuthState } from "@okta/okta-auth-js";
import { Server } from "../../Shared/Util/Server";

export function fetchUpdates(pageNumber: number, itemsPerPage: number, auth: AuthState): Promise<Api.INotificationsResponse|null> {
  return Server.get<Api.INotificationsResponse>(`/notification?pageNumber=${pageNumber}&resultsPerPage=${itemsPerPage}`, auth);
}
